<app-expansion-panel
  title="4. Please enter your commercial flights from the last 365 days."
  [description]="hasAnsweredFlights() ? 'answered' : 'not answered'"
  [descriptionClasses]="
    hasAnsweredFlights() ? ['question', 'answered'] : ['question', 'unanswered']
  "
  >
  <!-- Did not fly at all checkbox -->
  <div class="did-not-fly-container">
    <mat-checkbox [checked]="didNotFly" (change)="onDidNotFlyChange($event)">
      I did not fly at all
    </mat-checkbox>

    <mat-icon
      class="info-icon"
      matTooltip="Please indicate flights to and from stopovers if your journey was not direct."
      matTooltipPosition="above"
      matTooltipTouchGestures="on"
      #tooltip="matTooltip"
      (click)="tooltip.toggle()"
      >info</mat-icon
      >
    </div>

    <!-- Entered Flights List -->
    @for (flight of flights; track flight; let i = $index) {
      <div class="flight-row">
        <mat-form-field appearance="outline" class="flight-field" disabled>
          <mat-label>Departure</mat-label>
          <input matInput [value]="flight.departureAirport" disabled />
        </mat-form-field>
        <mat-form-field appearance="outline" class="flight-field" disabled>
          <mat-label>Destination</mat-label>
          <input matInput [value]="flight.destinationAirport" disabled />
        </mat-form-field>
        <mat-form-field appearance="outline" class="flight-field" disabled>
          <mat-label>Cabin Class</mat-label>
          <input matInput [value]="flight.cabinClass" disabled />
        </mat-form-field>
        <mat-form-field appearance="outline" class="flight-field" disabled>
          <mat-label>Emissions in kg CO₂</mat-label>
          <input matInput [value]="flight.causedEmissions" disabled />
        </mat-form-field>
        <button
          class="btn btn-warn"
          (click)="removeFlight(i)"
          aria-label="Remove Flight"
          >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }

    <!-- Editable Flight Form -->
    <form [formGroup]="flightForm" class="flight-form">
      <mat-form-field appearance="outline" class="flight-field">
        <mat-label>Departure Airport</mat-label>
        <input
          type="text"
          matInput
          formControlName="departureAirport"
          [matAutocomplete]="autoDeparture"
          [disabled]="didNotFly"
          />
        <mat-autocomplete
          #autoDeparture="matAutocomplete"
          [displayWith]="displayAirport"
          >
          @for (airport of filteredDepartureAirports; track airport) {
            <mat-option
              [value]="airport"
              >
              {{ displayAirport(airport) }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline" class="flight-field">
        <mat-label>Destination Airport</mat-label>
        <input
          type="text"
          matInput
          formControlName="destinationAirport"
          [matAutocomplete]="autoDestination"
          [disabled]="didNotFly"
          />
        <mat-autocomplete
          #autoDestination="matAutocomplete"
          [displayWith]="displayAirport"
          >
          @for (airport of filteredDestinationAirports; track airport) {
            <mat-option
              [value]="airport"
              >
              {{ displayAirport(airport) }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Cabin Class -->
      <mat-form-field appearance="outline" class="flight-field">
        <mat-label>Cabin Class</mat-label>
        <mat-select formControlName="cabinClass" [disabled]="didNotFly">
          @for (cabinClass of cabinClassOptions; track cabinClass) {
            <mat-option
              [value]="cabinClass"
              >
              {{ cabinClass }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!-- Emissions -->
      <mat-form-field appearance="outline" class="flight-field" disable>
        <mat-label>Emissions in kg CO₂</mat-label>
        <input matInput [value]="0" disabled />
      </mat-form-field>

      <button
        class="btn"
        (click)="addFlight()"
        [disabled]="flightForm.invalid || didNotFly"
        >
        <mat-icon>add</mat-icon>
      </button>
    </form>
  </app-expansion-panel>
